import ChevronLeft from './src/chevron-left-combined';
export default ChevronLeft;